import axios from 'axios';
import { BASE_URL } from '../utility/UrlConstants';
import { getHeaderConfig } from '../utility/HeaderConfig';


const getProduct = (size , filters: Object) => {
  return axios
    .get(
      `${BASE_URL}/products/get-product?page=0&size=${size}&sort=availableWeightAfterProcess,desc&productFilter=${JSON.stringify(
        filters
      )}`,
      getHeaderConfig()
    )
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

const orderStatus = (filters: Object) => {
  return axios
    .get(`${BASE_URL}/admin/others/orderstatus/get-all?filters=${JSON.stringify(
      filters
    )}`, getHeaderConfig())
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};


const getProductStatusData = (id: String) => {
  return axios
    .get(`${BASE_URL}/products/get-status?id=${id}`, getHeaderConfig())
    .then((response) => {
      const respData = {
        responseCode: response.status,
        response: response.data,
      };
      return respData;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getAllMetalStandards = (filters: Object) => {
  return axios
    .get(
      `${BASE_URL}/products/metadata/metalstandards/metadata/get-all?filters=${JSON.stringify(filters)}`, getHeaderConfig())
    
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

const getProductOrderItemPage = (filters:Object) => {
  return axios
    .get(
      `${BASE_URL}/products/productorders/productadvanceitems/get-page?prodAdvItemFilter=${JSON.stringify(filters)}`, getHeaderConfig())
    
    .then(response => {
      const respData = {
        responseCode: response.status,
        response: response.data
      };
      return respData;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
}

const getAllTax = (searchValue: Object) => {
  return axios
    .get(
      `${BASE_URL}/admin/accounts/tax/metadata/get-all?metaTaxationFilter=${JSON.stringify(
        searchValue
      )}`,
      getHeaderConfig()
    )
    .then((response) => {
      const respData = {
        responseCode: response.status,
        response: response.data,
      };
      return respData;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};


export { getProduct , orderStatus, getProductStatusData,getAllMetalStandards,getAllTax,getProductOrderItemPage};
